module.exports = __webpack_public_path__ + "static/img/head@2x.67328c46.png";